// extracted by mini-css-extract-plugin
module.exports = {"workoutDetailStyle":"HryT9eKUXICv65I3vqz8A"};